import { Grid, Button, Typography } from "@material-ui/core";
import {colors} from "./theme";
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import CallIcon from '@material-ui/icons/Call';

const Footer = () => {
  return (
    <div className="footer">
      <Grid container direction="column" justify="center" alignContent="center">
        <Grid item xs={12}>
          <Typography variant="h6" align="center" style={{ paddingBottom: '5px' }}>Castañeda Tacos and Restaurant</Typography>
        </Grid>
        <Grid item xs={12}>
          <div style={{
            height: '3px',
            backgroundImage: `linear-gradient(to right, transparent, ${colors.primaryGold}, transparent)`,
          }} />
        </Grid>

        <Grid item xs={12}>
          <div style={{ textAlign: 'center' }}>
            <a href="https://facebook.com/CastanedaTacosAndRestaurant" target="_blank" rel="noreferrer" style={{ padding: '5px' }}>
              <FacebookIcon
                style={{ color: '#3B5998' }}
                fontSize="large"
              />
            </a>
            {/*<a href="https://instagram.com" target="_blank" rel="noreferrer"  style={{ paddingLeft: '20px', paddingRight: '20px' }}>*/}
            {/*  <InstagramIcon*/}
            {/*    style={{ color: '#fbad50' }}*/}
            {/*    fontSize="large"*/}
            {/*  />*/}
            {/*</a>*/}

            <a href="tel: 574-971-8674" style={{ padding: '5px' }}>
              <CallIcon
                fontSize="large"
                style={{ color: '#42b154'}}
              />
            </a>

          </div>
        </Grid>

        <Grid item xs={12}>
          <div style={{
            height: '3px',
            backgroundImage: `linear-gradient(to right, transparent, ${colors.primaryGold}, transparent)`,
          }} />
        </Grid>

        <Grid item xs={12}>
          <div style={{ textAlign: 'center' }}>
            <Button
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              size="large"
              endIcon={<ArrowUpwardIcon>send</ArrowUpwardIcon>}
            >Back To Top
            </Button>
          </div>
        </Grid>

      </Grid>

      <div style={{ textAlign: 'end' }}>
        <Typography style={{ paddingRight: '10px', color: '#b3b3b3', fontStyle: 'italic' }}>Website created by: Caleb Nunez</Typography>
      </div>
    </div>
  );
};

export default Footer;
